import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { UserSettingsComponent } from "./components/user-settings/user-settings.component";
import { ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "../shared/shared.module";
import { SettingsComponent } from "./pages/settings/settings.component";
import { ReportEmailSettingsComponent } from "./components/report-email-settings/report-email-settings.component";
import { CurrencyService } from "@core/services/currency.service";
import { ConfigurationWizardComponent } from "@app/settings/pages/configuration-wizard/configuration-wizard.component";
import { RouterModule } from "@angular/router";

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, RouterModule, SharedModule],
  declarations: [
    UserSettingsComponent,
    SettingsComponent,
    ReportEmailSettingsComponent,
    ConfigurationWizardComponent,
  ],
  entryComponents: [SettingsComponent],
  providers: [CurrencyService],
  exports: [ConfigurationWizardComponent],
})
export class SettingsModule {}



// WEBPACK FOOTER //
// /app/src/app/settings/settings.module.ts